import { FxStatusLabel, type FxStatus } from './FxStatusLabel'
import type { EvaluationStatus } from '@/types/domain'

/**
 * The API's evaluation status, said in the design system's four words.
 *
 * The gateway distinguishes states the design does not draw: `noMatch` and
 * `other` are both "this document has no usable reading", which the design
 * calls `unclear` — the state that sends a document to review. Rendering is
 * `FxStatusLabel`'s, so a status looks the same wherever it appears.
 */
const toStatus: Record<EvaluationStatus, FxStatus> = {
  neu: 'neu',
  inProgress: 'inProgress',
  problematic: 'unclear',
  complete: 'done',
  noMatch: 'unclear',
  other: 'unclear',
}

export function FxStatusBadge({
  status,
  className,
}: {
  status: EvaluationStatus
  className?: string
}) {
  return <FxStatusLabel status={toStatus[status] ?? 'unclear'} chip size="small" className={className} />
}

/**
 * Confidence colours relative to the template's review threshold. Below the
 * threshold is red, within 0.10 above it amber, higher green — the same bands
 * the annotated page images use.
 */
export function confidenceTone(confidence: number, threshold: number) {
  if (confidence < threshold) return 'danger' as const
  if (confidence < threshold + 0.1) return 'warning' as const
  return 'success' as const
}
